import { Button } from '@ordr-as/umami-react/button';
import React, { useState } from 'react';
import QuantityDialog from '../QuantityDialog';
import { OrderLineDto } from '../../../../../../generated-api';

type QuantityBoxProps = { isActive: boolean; orderLine: OrderLineDto };

const QuantityBox = (props: QuantityBoxProps) => {
  const { orderLine, isActive } = props;
  const [showQuantityDialog, setShowQuantityDialog] = useState(false);

  return (
    <>
      {isActive ? (
        <Button
          className="h-6 w-6 min-h-[32px] min-w-[32px] bg-brand-white text-bold text-small  border border-brand-secondary rounded"
          onClick={() => setShowQuantityDialog(true)}
          isDisabled={!isActive}
        >
          {orderLine.quantity}
        </Button>
      ) : (
        <div className="h-6 w-6 min-h-[32px] min-w-[32px] flex items-center text-sm justify-center text-bold  border border-grey-medium rounded">
          {orderLine.quantity}
        </div>
      )}
      {showQuantityDialog && <QuantityDialog orderLine={orderLine} setShowQuantityDialog={setShowQuantityDialog} />}
    </>
  );
};

export default React.memo(QuantityBox);
